// /////////////////////////////////////////////////////////////
// [ファイル] colors.ts
// [概要] プロジェクト共通のカラー定数。
//        画面横断で使い回す色はここに集約し、各コンポーネントで
//        リテラル値を直接書かずに import して参照すること。
// /////////////////////////////////////////////////////////////

// アプリ標準の背景色（薄いブルーグレー）
// App.css の .App background-color と同一値。変更する際は両方を更新すること。
export const APP_BACKGROUND_COLOR = '#e5e9f1';
